/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import ChildIssuesIcon from '@atlaskit/icon/glyph/child-issues';
var rotateSvg = css({
  transform: 'rotate(180deg)',
  display: 'inline-block'
});

/**
 * ChildIssuesIcon but 180 degrees rotated
 */
var RelatedLinksActionIcon = function RelatedLinksActionIcon() {
  return jsx("span", {
    css: rotateSvg
  }, jsx(ChildIssuesIcon, {
    label: "View recent links..."
  }));
};
export default RelatedLinksActionIcon;